import ArtCard from "../components/ArtCard";
import { mediaSrc, isVideo } from "../utils/media";
import "../styles/FeedbackPage.css";
import "../styles/HomePage.css";
import Tiger from "../images/painting/tiger.jpeg";

function FeedbackCard({ item }) {
  const src = mediaSrc(item.picha || item.img || item.avatar);
  const video = isVideo({ ...item, img: src || item.img || item.picha });
  const name = item.name || item.title || "Guest";

  return (
    <div className="fb-card">
      <div className="fb-picha-wrap">
        {src && video ? (
          <video src={src} className="fb-picha" muted playsInline controls />
        ) : src ? (
          <img src={src} alt={`${name}'s `} className="fb-picha" />
        ) : (
          <div className="fb-picha-placeholder">Photo</div>
        )}
      </div>
      <div className="fb-card-footer">
        <div className="fb-avatar">
          {src && !video ? (
            <img src={src} alt={name} className="fb-avatar-img" />
          ) : (
            <div className="fb-avatar-initials">{item.initials || name.slice(0, 2).toUpperCase()}</div>
          )}
        </div>
        <div>
          <div className="fb-name">{name}</div>
          {item.role && <div className="fb-role">{item.role}</div>}
        </div>
      </div>
    </div>
  );
}

export default function HomePage({ setPage, shopItems, galleryItems = [], feedbackItems = [] }) {
  const featured = (galleryItems.length ? galleryItems : shopItems).slice(0, 4);

  return (
    <div className="page">
      <div className="hero" style={{ backgroundImage: `url(${Tiger})` }}>
        <div className="hero-overlay" />
        <div className="hero-rule" />
        <div className="hero-label">Dickson Art Gallery · Zanzibar, Tanzania</div>
        <h1 className="hero-title">
          Where <em>Art</em>
          <br />
          Speaks
        </h1>
        <p className="hero-sub">
          A sanctuary for fine art — celebrating African creativity, contemporary
          expression, and the timeless language of colour and form.
        </p>
      </div>

      <div className="home-stats">
        {[
          ["50+",      "Artworks"],
          ["200+",     "Students"],
          ["15+",      "Exhibitions"],
          ["Est. 2018","Founded"],
        ].map(([n, l]) => (
          <div key={l} className="home-stat">
            <div className="home-stat-num">{n}</div>
            <div className="home-stat-label">{l}</div>
          </div>
        ))}
      </div>

      <div className="section">
        <div className="section-header">
          <div className="section-ornament">
            <div className="section-ornament-line" />
            <span className="section-label">Selected Works</span>
            <div className="section-ornament-line" />
          </div>
          <h2 className="section-title">
            Featured <em>Artworks</em>
          </h2>
          <div className="section-rule" />
        </div>

        {featured.length > 0 ? (
          <div className="cards-grid">
            {featured.map((item) => (
              <ArtCard
                key={item.id}
                item={item}
                variant={galleryItems.length ? "gallery" : undefined}
                onClick={() => setPage(galleryItems.length ? "gallery" : "shop")}
              />
            ))}
          </div>
        ) : (
          <div className="home-empty">
            <div className="home-empty-icon">🎨</div>
            <p>No artworks yet. Add some via the Admin panel.</p>
          </div>
        )}

        {featured.length > 0 && (
          <div style={{ textAlign: "center", marginTop: 50 }}>
            <button className="btn btn-outline" onClick={() => setPage("gallery")}>
              View Gallery →
            </button>
          </div>
        )}
      </div>

      <div className="home-classroom-promo">
        <div className="section home-classroom-inner">
          <div>
            <div className="section-ornament" style={{ justifyContent: "flex-start" }}>
              <div className="section-ornament-line" style={{ maxWidth: 40 }} />
              <span className="section-label">Art Education</span>
            </div>
            <h2 className="section-title" style={{ textAlign: "left", marginTop: 14 }}>
              Learn in
              <br />
              <em>The Classroom</em>
            </h2>
            <div className="section-rule" style={{ margin: "22px 0" }} />
            <p className="home-classroom-desc">
              Join hands-on workshops covering portraiture, landscape, colour theory,
              and more. Every session is archived with photographs and dates.
            </p>
            <button
              className="btn btn-ochre-outline"
              onClick={() => setPage("classroom")}
            >
              Browse Sessions →
            </button>
          </div>

          <div className="home-classroom-features">
            {[
              ["📚", "Expert-led workshops for all levels"],
              ["🎨", "Oil, watercolour, acrylic & more"],
              ["📸", "Every session photographed & archived"],
              ["🏆", "Certificates upon completion"],
            ].map(([ico, txt]) => (
              <div key={txt} className="home-classroom-feature">
                <span className="home-classroom-feature-icon">{ico}</span>
                <span className="home-classroom-feature-text">{txt}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="section fb-section">
        <div className="section-header">
          <div className="section-ornament">
            <div className="section-ornament-line" />
            <span className="section-label">From Our Visitors</span>
            <div className="section-ornament-line" />
          </div>
          <h2 className="section-title">
            Happy <em>Customers</em>
          </h2>
          <div className="section-rule" />
        </div>

        <div className="section fbp-section">
          {feedbackItems.length === 0 ? (
            <p style={{ textAlign: "center", color: "var(--ink-faint)", padding: "40px 0" }}>
              No feedback photos yet.
            </p>
          ) : (
            <div className="fb-horizontal-scroll">
              {feedbackItems.map((item) => (
                <FeedbackCard key={item.id} item={item} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
